import { createContext, useContext } from "react";

export const PrintModeContext = createContext(false);

export function usePrintMode() {
    return useContext(PrintModeContext);
}
